module.exports = __webpack_public_path__ + "static/10-7cbd7866a7da402f451431a2838373ad.jpeg";